var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "app-container" }, [
        _c(
          "div",
          { staticStyle: { height: "30px" } },
          [
            _c(
              "vxe-button",
              {
                directives: [
                  {
                    name: "auth",
                    rawName: "v-auth",
                    value: "EXPORT",
                    expression: "`EXPORT`",
                  },
                ],
                on: { click: _vm.export2Excel },
              },
              [_vm._v("导出")]
            ),
            _vm.domain !== "dealer"
              ? _c(
                  "vxe-button",
                  {
                    directives: [
                      {
                        name: "auth",
                        rawName: "v-auth",
                        value: "BATCHAPPROVE",
                        expression: "`BATCHAPPROVE`",
                      },
                    ],
                    on: {
                      click: function ($event) {
                        _vm.batchDialogVisible = true
                      },
                    },
                  },
                  [_vm._v("批量审批")]
                )
              : _vm._e(),
            _vm.domain !== "dealer"
              ? _c(
                  "vxe-button",
                  {
                    directives: [
                      {
                        name: "auth",
                        rawName: "v-auth",
                        value: "ASSIGN",
                        expression: "`ASSIGN`",
                      },
                    ],
                    on: { click: _vm.handleTransfer },
                  },
                  [_vm._v("指派")]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticStyle: {
                  float: "right",
                  color: "#848484",
                  display: "flex",
                  "line-height": "28px",
                },
              },
              [
                !_vm.showFilter
                  ? _c(
                      "div",
                      { staticStyle: { float: "right", display: "flex" } },
                      [
                        _c(
                          "a-select",
                          {
                            staticStyle: {
                              "margin-right": "1rem",
                              width: "220px",
                            },
                            attrs: {
                              placeholder: "请选择经理部",
                              mode: "multiple",
                              maxTagCount: 1,
                              "filter-option": false,
                            },
                            model: {
                              value: _vm.queryCondition.regionIds,
                              callback: function ($$v) {
                                _vm.$set(_vm.queryCondition, "regionIds", $$v)
                              },
                              expression: "queryCondition.regionIds",
                            },
                          },
                          _vm._l(_vm.sectorList, function (item) {
                            return _c(
                              "a-select-option",
                              {
                                key: item.sectorId,
                                attrs: { value: item.sectorId },
                              },
                              [_vm._v(" " + _vm._s(item.sectorName) + " ")]
                            )
                          }),
                          1
                        ),
                        _c("a-input", {
                          staticStyle: {
                            width: "200px",
                            "margin-right": "1rem",
                            height: "28px",
                          },
                          attrs: {
                            placeholder: "请输入提报名称/提报编码",
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.queryByPage(1)
                            },
                          },
                          model: {
                            value: _vm.queryCondition.applyNameOrCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryCondition,
                                "applyNameOrCode",
                                $$v
                              )
                            },
                            expression: "queryCondition.applyNameOrCode",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  [
                    !_vm.showFilter
                      ? _c(
                          "vxe-button",
                          {
                            attrs: { status: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.queryByPage(1)
                              },
                            },
                          },
                          [_vm._v("搜索")]
                        )
                      : _vm._e(),
                    !_vm.showFilter
                      ? _c(
                          "vxe-button",
                          {
                            staticClass: "filter-search-item",
                            on: {
                              click: function ($event) {
                                return _vm.resetForm(1)
                              },
                            },
                          },
                          [_vm._v("重置")]
                        )
                      : _vm._e(),
                    _c(
                      "vxe-button",
                      { attrs: { type: "warning" }, on: { click: _vm.cb } },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.showFilter ? "收起" : "筛选") + " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { "margin-top": "20px" } },
          [
            _c("el-collapse-transition", [
              _vm.showFilter
                ? _c(
                    "div",
                    [
                      _c("SiftReimburse", {
                        attrs: {
                          data: _vm.queryCondition,
                          "sift-type": "writeOff",
                          "sector-list": _vm.sectorList,
                        },
                      }),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "center",
                            "padding-bottom": "10px",
                            "margin-bottom": "10px",
                          },
                          attrs: { slot: "footer" },
                          slot: "footer",
                        },
                        [
                          _c(
                            "vxe-button",
                            {
                              attrs: { status: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.queryByPage(1)
                                },
                              },
                            },
                            [_vm._v("搜索")]
                          ),
                          _c(
                            "vxe-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm()
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
        _c(
          "div",
          [
            _c("vxe-toolbar", {
              ref: "toolbarRef",
              staticStyle: {
                height: "39px",
                "margin-top": "-10px",
                background: "#F3F4F7",
              },
              attrs: { custom: "" },
            }),
            _c(
              "vxe-table",
              {
                ref: "xTable",
                staticClass: "mytable-scrollbar",
                attrs: {
                  id: "toolbar_reibursement",
                  loading: _vm.LoadingTable,
                  border: "",
                  "show-header-overflow": "",
                  "show-overflow": "",
                  align: "center",
                  "column-config": { resizable: true },
                  stripe: "",
                  round: "",
                  "custom-config": {
                    storage: true,
                    checkMethod: _vm.checkColumnMethod,
                  },
                  "max-height":
                    _vm.$store.state.app.height - 130 < 500
                      ? 500
                      : _vm.$store.state.app.height - 130,
                  "scroll-y": { enabled: false },
                  "row-config": { isHover: true, height: 30, isCurrent: true },
                  data: _vm.tableData,
                },
                on: { "cell-dblclick": _vm.cellClickEvent },
              },
              [
                _c("vxe-column", {
                  attrs: { type: "checkbox", width: "60", align: "center" },
                }),
                _c("vxe-column", {
                  attrs: {
                    type: "seq",
                    title: "序号",
                    width: "60",
                    align: "center",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    visible: false,
                    title: "id",
                    field: "id",
                    width: "100",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    visible: false,
                    title: "历史审批流程id",
                    field: "writeoffHistOrderId",
                    width: "100",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    visible: false,
                    title: "活动计划编码",
                    field: "planCode",
                    width: "120",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "活动提报编码",
                    field: "planApplyCode",
                    width: "120",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "活动核销编码",
                    field: "writeoffCode",
                    width: "120",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "经理部名称",
                    field: "regionName",
                    width: "120",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    visible: false,
                    title: "经销商名称",
                    field: "dealerName",
                    width: "200",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "经销商名称",
                    field: "dealerShortName",
                    width: "200",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "申请人",
                    field: "createUserName",
                    width: "100",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "活动提报名称",
                    field: "planApplyName",
                    width: "150",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "预算类型",
                    field: "budgetTypeName",
                    width: "120",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "一级来源",
                    field: "oneLevelName",
                    width: "120",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "二级来源",
                    field: "twoLevelName",
                    width: "120",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "三级来源",
                    field: "threeLevelName",
                    width: "120",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "计划开始时间",
                    field: "planStartTime",
                    width: "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormat")(
                                  row.planStartTime,
                                  "yyyy-MM-dd"
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "计划结束时间",
                    field: "planEndTime",
                    width: "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFormat")(
                                  row.planEndTime,
                                  "yyyy-MM-dd"
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "发起时间",
                    field: "writeoffFlowStartTime",
                    width: "160",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "实际时间",
                    field: "actualStartTime",
                    width: "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.actualStartTime
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("dateFormat")(
                                      row.actualStartTime,
                                      "yyyy-MM-dd"
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "品系",
                    field: "strainsNameList",
                    width: "200",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "车型代码",
                    field: "vehicleCodeList",
                    width: "200",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "提报审批金额（元）",
                    field: "approveApplyCost",
                    width: "130",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("toThousandNumFilter")(
                                  row.approveApplyCost
                                )
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "集客实际",
                    field: "customerActual",
                    width: "100",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "现场订车数",
                    field: "orderQuantity",
                    width: "100",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "核销审核费用（元）",
                    field: "approveWriteoffCost",
                    width: "130",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.approveWriteoffCost
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("toThousandNumFilter")(
                                      row.approveWriteoffCost
                                    )
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "核销比例（%）",
                    field: "writeRate",
                    width: "110",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "考评金额（元）",
                    field: "assessmentCost",
                    width: "120",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "结算金额（元）",
                    field: "payAmounts",
                    width: "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("toThousandNumFilter")(row.payAmounts)
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("vxe-column", {
                  attrs: { title: "结算时间", field: "payTime", width: "160" },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "当前核销审批节点",
                    field: "writeoffNode",
                    width: "160",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "当前核销节点审批人",
                    field: "writeoffAuditorNames",
                    width: "160",
                  },
                }),
                _c("vxe-column", {
                  attrs: {
                    title: "核销状态",
                    field: "writeoffStatus",
                    width: "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.writeoffStatus === "0"
                            ? _c("span", [_vm._v("待反馈")])
                            : _vm._e(),
                          row.writeoffStatus === "1"
                            ? _c("span", [_vm._v("待核销")])
                            : _vm._e(),
                          row.writeoffStatus === "2"
                            ? _c("span", [_vm._v("审核中")])
                            : _vm._e(),
                          row.writeoffStatus === "3"
                            ? _c("span", [_vm._v("审核通过")])
                            : _vm._e(),
                          row.writeoffStatus === "4"
                            ? _c("span", [_vm._v("已驳回")])
                            : _vm._e(),
                          row.writeoffStatus === "5"
                            ? _c("span", [_vm._v("超期放弃")])
                            : _vm._e(),
                          row.writeoffStatus === "6"
                            ? _c("span", [_vm._v("不通过")])
                            : _vm._e(),
                          row.writeoffStatus === "7"
                            ? _c("span", [_vm._v("放弃核销")])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("vxe-column", {
                  attrs: {
                    field: "address",
                    title: "操作",
                    width: "380",
                    fixed: "right",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "handle-box",
                              staticStyle: { height: "30px" },
                            },
                            [
                              true
                                ? _c(
                                    "a-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value: "VIEW",
                                          expression: "`VIEW`",
                                        },
                                      ],
                                      staticClass: "AMargin",
                                      attrs: { type: "link" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.DetailedFun(row)
                                        },
                                      },
                                    },
                                    [_vm._v("详细")]
                                  )
                                : _vm._e(),
                              (row.writeoffStatus === "0" ||
                                row.writeoffStatus === "4") &&
                              _vm.hasDeletePermission
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: {
                                        status: "primary",
                                        type: "link",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteRow(row)
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                              (+row.writeoffStatus < 2 ||
                                row.writeoffStatus == null ||
                                row.writeoffStatus === "4") &&
                              row.domain == "dealer"
                                ? _c(
                                    "a-button",
                                    {
                                      directives: [
                                        {
                                          name: "auth",
                                          rawName: "v-auth",
                                          value: "FEEDBACK",
                                          expression: "`FEEDBACK`",
                                        },
                                      ],
                                      staticClass: "AMargin",
                                      attrs: { type: "link" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.reimburseFun(row)
                                        },
                                      },
                                    },
                                    [_vm._v("反馈")]
                                  )
                                : _vm._e(),
                              row.domain == "dealer" &&
                              (row.writeoffStatus === "1" ||
                                row.writeoffStatus === "4") &&
                              (_vm.user.userId == row.writeoffAuditorIds ||
                                row.writeoffAuditorIds == null ||
                                row.writeoffAuditorIds === "")
                                ? _c(
                                    "a-button",
                                    {
                                      staticClass: "AMargin",
                                      attrs: { type: "link" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.startApprove(row)
                                        },
                                      },
                                    },
                                    [_vm._v("发起核销")]
                                  )
                                : _vm._e(),
                              (row.writeoffStatus === "0" ||
                                row.writeoffStatus === "1" ||
                                row.writeoffStatus === "4") &&
                              row.domain == "dealer"
                                ? _c(
                                    "a-button",
                                    {
                                      staticClass: "AMargin color-red",
                                      attrs: { type: "link" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.relinquishFun(row)
                                        },
                                      },
                                    },
                                    [_vm._v("放弃核销")]
                                  )
                                : _vm._e(),
                              row.writeoffStatus === "7"
                                ? _c(
                                    "a-button",
                                    {
                                      staticClass: "AMargin color-red",
                                      attrs: { type: "link" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.recoWriteoffFun(row)
                                        },
                                      },
                                    },
                                    [_vm._v("恢复核销")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c("vxe-pager", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.LoadingTable,
                  expression: "!LoadingTable",
                },
              ],
              attrs: {
                "current-page": _vm.pagination.current,
                "page-size": _vm.pagination.size,
                total: _vm.pagination.total,
                layouts: [
                  "PrevPage",
                  "JumpNumber",
                  "NextPage",
                  "FullJump",
                  "Sizes",
                  "Total",
                ],
              },
              on: { "page-change": _vm.changePage },
            }),
            _c("vxe-modal", {
              attrs: {
                title: "查看详情",
                width: "600",
                height: "400",
                mask: false,
                "lock-view": false,
                resize: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function () {
                    return [
                      _c(
                        "vxe-table",
                        {
                          attrs: {
                            border: "inner",
                            "auto-resize": "",
                            "show-overflow": "",
                            height: "auto",
                            "row-config": { isHover: true },
                            "show-header": false,
                            "sync-resize": _vm.showDetails,
                            data: _vm.detailData,
                          },
                        },
                        [
                          _c("vxe-column", {
                            attrs: { field: "label", width: "40%" },
                          }),
                          _c("vxe-column", { attrs: { field: "value" } }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.showDetails,
                callback: function ($$v) {
                  _vm.showDetails = $$v
                },
                expression: "showDetails",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "a-modal",
        {
          attrs: {
            title: "选择导出项",
            visible: _vm.dialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            cancel: function ($event) {
              _vm.dialogVisible = false
            },
          },
        },
        [
          _c(
            "a-radio-group",
            {
              model: {
                value: _vm.ExportItem,
                callback: function ($$v) {
                  _vm.ExportItem = $$v
                },
                expression: "ExportItem",
              },
            },
            [
              _c("a-radio", { attrs: { value: 0 } }, [_vm._v("导出全部")]),
              _c("a-radio", { attrs: { value: 1 } }, [_vm._v("导出当前页")]),
              _c("a-radio", { attrs: { value: 2, disabled: _vm.disabled } }, [
                _vm._v("导出已选择项"),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "vxe-button",
                {
                  attrs: {
                    status: "primary",
                    loading: _vm.outExcelButtonLocading,
                  },
                  on: { click: _vm.outExcel },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审批信息",
            visible: _vm.appdialogVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.appdialogVisible = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "请输入审批意见",
              maxlength: "300",
              "show-word-limit": "",
            },
            model: {
              value: _vm.approveMsg,
              callback: function ($$v) {
                _vm.approveMsg = $$v
              },
              expression: "approveMsg",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  attrs: { type: "primary", loading: _vm.approveBtnLoading },
                  on: {
                    click: function ($event) {
                      return _vm.approveConfirmFun()
                    },
                  },
                },
                [_vm._v("发起审批")]
              ),
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.appdialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            title: "批量审批信息",
            visible: _vm.batchDialogVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchDialogVisible = $event
            },
            cancel: _vm.onClose,
          },
        },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "请输入审批意见",
              maxlength: "300",
              "show-word-limit": "",
            },
            model: {
              value: _vm.batchApproveMsg,
              callback: function ($$v) {
                _vm.batchApproveMsg = $$v
              },
              expression: "batchApproveMsg",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary", loading: _vm.approveBtnLoading },
                  on: {
                    click: function ($event) {
                      return _vm.approveBatch()
                    },
                  },
                },
                [_vm._v("同意")]
              ),
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.batchDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审批信息",
            visible: _vm.taskDialogVisible,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.taskDialogVisible = $event
            },
          },
        },
        [
          _c(
            "vxe-table",
            {
              ref: "xApprove",
              attrs: {
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                loading: _vm.approveLoading,
                "max-height": "370",
                align: "center",
                "scroll-y": { enabled: false },
                data: _vm.taskListData,
                reserve: true,
                "row-config": { isCurrent: true, isHover: true },
              },
            },
            [
              _c("vxe-column", {
                attrs: { type: "seq", title: "序号", width: "60" },
              }),
              _c("vxe-column", {
                attrs: { field: "displayName", title: "节点名称" },
              }),
              _c("vxe-column", {
                attrs: { field: "operatorName", title: "审批人" },
              }),
              _c("vxe-column", {
                attrs: { field: "operateType", title: "操作类型" },
              }),
              _c("vxe-column", {
                attrs: { field: "approveCost", title: "审批金额" },
              }),
              _c("vxe-column", {
                attrs: { field: "finishTime", title: "处理时间", width: "100" },
              }),
              _c("vxe-column", {
                attrs: { field: "approveMsg", title: "审批意见" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "审批信息",
            visible: _vm.transdialogVisible,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.transdialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "demo-input-suffix",
              staticStyle: { "padding-bottom": "20px" },
            },
            [
              _vm._v(" 转派人： "),
              _c("el-input", {
                staticStyle: { width: "35%" },
                attrs: { placeholder: "请选择转派的用户" },
                on: { focus: _vm.chooseUser },
                model: {
                  value: _vm.operatorUser,
                  callback: function ($$v) {
                    _vm.operatorUser = $$v
                  },
                  expression: "operatorUser",
                },
              }),
            ],
            1
          ),
          _c("el-input", {
            attrs: {
              type: "textarea",
              placeholder: "请输入审批意见",
              maxlength: "300",
              "show-word-limit": "",
            },
            model: {
              value: _vm.approveMsg,
              callback: function ($$v) {
                _vm.approveMsg = $$v
              },
              expression: "approveMsg",
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  attrs: {
                    loading: _vm.TransferApproveBtnLoading,
                    status: "primary",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.transferApprove()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.transdialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择用户",
            visible: _vm.userDialogVisible,
            width: "75%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.userDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px" } },
            [
              _c("el-input", {
                style: { width: "80%" },
                attrs: { placeholder: "输入用户名称", clearable: "" },
                on: { change: _vm.handleFilter },
                model: {
                  value: _vm.userName,
                  callback: function ($$v) {
                    _vm.userName = $$v
                  },
                  expression: "userName",
                },
              }),
              _c(
                "vxe-button",
                {
                  staticClass: "filter-search-item",
                  staticStyle: { float: "right" },
                  attrs: { status: "primary" },
                  on: { click: _vm.handleFilter },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
          _c(
            "vxe-table",
            {
              ref: "Xuser",
              attrs: {
                border: "",
                "show-header-overflow": "",
                "show-overflow": "",
                "column-config": { resizable: true },
                stripe: "",
                round: "",
                loading: _vm.userLoading,
                "max-height": "350",
                align: "center",
                "scroll-y": { enabled: false },
                data: _vm.userLists,
                reserve: true,
                "row-config": { isCurrent: true, isHover: true },
                "radio-config": {
                  strict: false,
                  labelField: "seq",
                  trigger: "row",
                  isCurrent: true,
                  isHover: true,
                },
              },
            },
            [
              _c("vxe-column", { attrs: { type: "radio", width: "60" } }),
              _c("vxe-column", {
                attrs: { visible: false, field: "id", title: "用户id" },
              }),
              _c("vxe-column", {
                attrs: { type: "seq", title: "序号", width: "60" },
              }),
              _c("vxe-column", {
                attrs: { field: "name", title: "用户名称", width: "110" },
              }),
              _c("vxe-column", {
                attrs: { field: "department", title: "所属组织结构" },
              }),
            ],
            1
          ),
          _c("vxe-pager", {
            attrs: {
              loading: _vm.userLoading,
              "current-page": _vm.userTablePage.currentPage,
              "page-size": _vm.userTablePage.pageSize,
              total: _vm.userTablePage.totalResult,
              layouts: [
                "PrevPage",
                "JumpNumber",
                "NextPage",
                "FullJump",
                "Sizes",
                "Total",
              ],
            },
            on: { "page-change": _vm.handlePageChange },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "vxe-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.userDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "vxe-button",
                {
                  attrs: { status: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleChooseUser()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提报审核流程",
            visible: _vm.checkFlowShow,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.checkFlowShow = $event
            },
          },
        },
        [_c("checkFlow", { attrs: { data: _vm.budgetData } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }